import { render, staticRenderFns } from "./PortalNodeEditor.vue?vue&type=template&id=29f3b54e&scoped=true&"
import script from "./PortalNodeEditor.vue?vue&type=script&lang=js&"
export * from "./PortalNodeEditor.vue?vue&type=script&lang=js&"
import style0 from "./PortalNodeEditor.vue?vue&type=style&index=0&id=29f3b54e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f3b54e",
  null
  
)

export default component.exports